import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";

import { PageAlert } from "capitalrx-components";

import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";
import { pharmacySearchActions } from "@/App/actions";
import { GeneralTypes } from "@/types";

function* searchPharmacy(data: GeneralTypes.QueryOptions): Generator {
  return yield apiService({
    url: "/pharmacy/list",
    method: "POST",
    data,
  });
}

export function* searchForPharmacyWorker(action: ReturnType<typeof pharmacySearchActions.searchForPharmacy>): SagaIterator {
  const { searchForPharmacyResults } = pharmacySearchActions;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { results, result_count } = yield call(searchPharmacy, payload);

    yield put(searchForPharmacyResults({ results, result_count }));
    yield put(stopSubmit(formName));
  } catch (error) {
    yield put(stopSubmit(formName));
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* searchForPharmacyWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_PHARMACY_LIST, searchForPharmacyWorker);
}
